import { render, staticRenderFns } from "./preview-editor.vue?vue&type=template&id=9ecc6aac&scoped=true"
import script from "./preview-editor.vue?vue&type=script&lang=js"
export * from "./preview-editor.vue?vue&type=script&lang=js"
import style0 from "./preview-editor.vue?vue&type=style&index=0&id=9ecc6aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecc6aac",
  null
  
)

export default component.exports